import { useEffect, useState } from "react";
import { Button, Checkbox, Col, Form, Input, Row, Tabs, TabsProps } from "antd";
import { useGetData } from "../../../../Network/useGetQueryData";
import { SearchIcon } from "../../../../Icons/SearchIcon";
import "./style.scss";
import { MarkedIcon } from "../../../../Icons/MarkedIcon";
import { Loading } from "../../../../components/Loading";
import { uniqBy } from "lodash";
import { useTranslation } from "react-i18next";

export const ServiceStep = ({
  onChangeStep,
  setFormData,
  formData,
}: {
  onChangeStep?: (step: number) => void;
  setFormData?: (data: any) => void;
  formData: any;
}) => {
  const { t, i18n } = useTranslation();
  const [searchKey, setSearchKey] = useState<any>();
  const [selectedTab, setSelectedTab] = useState<string>(formData?.types);
  const [selectedServices, setSelectedServices] = useState<number[]>([]);
  const [selectedServicesName, setSelectedServicesName] = useState<any[]>([]);

  const { data: categories } = useGetData<{
    data: any;
  }>({
    queryKey: ["formData?.types"],
    url: `category?parentId=${formData?.types}&includeParentFilter=true&offset=0&limit=10&withDeleted=false`,
    params: { searchKey: searchKey },
    options: {
      enabled: !!formData?.types,
      queryKey: ["formData?.types", formData?.types],
    },
  });

  const { data: services, isLoading } = useGetData<{
    data: any;
  }>({
    queryKey: ["service-categoryId"],
    url: `service?categoryIds=${selectedTab}&offset=0&limit=50&withDeleted=false`,
    params: { searchKey: searchKey },
    options: {
      enabled: !!selectedTab,
      queryKey: ["service-categoryId", selectedTab, formData],
    },
  });

  const items: TabsProps["items"] = [
    {
      key: formData?.types,
      label: t("shared.all"),
    },
    ...(categories?.data?.items || [])?.map((cat: any) => {
      return {
        key: `${cat?.id}`,
        label: cat?.name?.[i18n.language || "en"],
      };
    }),
  ];

  useEffect(() => {
    if (formData?.servicesIds)
      setSelectedServices(
        selectedServices
          ? [...selectedServices, ...formData?.servicesIds]
          : [formData?.servicesIds],
      );
  }, [formData]);

  return (
    <Form>
      <p className="form-section-title">{t("requests.chooseTest")}</p>
      <div className="services-list">
        <div className="form-list-header">
          <div className="header-search">
            <Input
              size="large"
              placeholder={t("shared.searchTest")}
              prefix={<SearchIcon />}
              onChange={(e) => setSearchKey(e.target.value)}
            />
            {categories?.data?.items && categories?.data?.items?.length > 0 && (
              <Tabs
                defaultActiveKey={formData?.types}
                items={items}
                onChange={setSelectedTab}
              />
            )}
          </div>
        </div>

        {services?.data?.items && services?.data?.items?.length > 0 ? (
          <Row gutter={16}>
            {services?.data?.items?.map((service: any) => (
              <Col key={service.id} lg={12} xs={24} sm={24}>
                <Checkbox
                  checked={selectedServices?.indexOf(service?.id) !== -1}
                  defaultChecked={selectedServices?.indexOf(service?.id) !== -1}
                  onChange={(e) => {
                    setSelectedServices((prev) => {
                      if (e.target.checked)
                        return uniqBy([...prev, service?.id], (num) => num);
                      else
                        return uniqBy(
                          prev.filter((item) => item !== service?.id),
                          (num) => num,
                        );
                    });
                    setSelectedServicesName((prev) => {
                      if (e.target.checked) {
                        return uniqBy(
                          [
                            ...prev,
                            {
                              serviceId: service?.id,
                              name: service?.name?.[i18n.language || "en"],
                            },
                          ],
                          "serviceId",
                        );
                      } else {
                        return uniqBy(
                          prev.filter((item) => item.serviceId !== service?.id),
                          "serviceId",
                        );
                      }
                    });
                  }}
                  value={service?.id}
                >
                  {service?.name?.[i18n.language || "en"]}
                  {selectedServices?.indexOf(service?.id) !== -1 && (
                    <span>
                      <MarkedIcon />
                    </span>
                  )}
                </Checkbox>
              </Col>
            ))}
          </Row>
        ) : isLoading ? (
          <Loading />
        ) : (
          <p
            style={{
              height: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {t("requests.noServicesForType")}
          </p>
        )}

        <div className="steps-action-footer">
          <Button
            type="primary"
            onClick={() => {
              if (selectedServices?.length <= 0) return;

              setFormData?.({
                ...formData,
                servicesIds: selectedServices,
                services: formData?.services
                  ? [...formData?.services, ...selectedServicesName]
                  : selectedServicesName,
              });
              onChangeStep?.(2);
            }}
          >
            {t("shared.next")}
          </Button>

          <Button style={{ margin: "0 8px" }} onClick={() => onChangeStep?.(0)}>
            {t("shared.back")}
          </Button>
        </div>
      </div>
    </Form>
  );
};
